import { defineStore } from 'pinia';
import { router } from '/@/router';
import { h,nextTick } from 'vue';
import { i18n } from '/@common/i18n';
import { Session } from '/@common/utils/storage';
import { getPersonagePrice } from '/@/api/personal';
import DSBridge from '/@common/utils/dsBridge/dsBridge';
import {
	listDialogues,
	listFile,
	listConversations,
	updateConversation,
	updateCollectStatus,
	deleteConversation,
	addConversation,
	closeDialogueConn,
	feedbackListLabel,
	updateNameConversation,
	updateNameWithConversation,
	listConversationsByPage,
	getPluginInfo,
	getUserPreference,
	saveOrUpdateUserPreference,
	detail,
	getLatestConversation,
	conversationGuestDetail,
	guestConversationAdd,
	getGuestRoleIdDetails,
	listGuestDialogues,
	updateGuestDialogueName,
	closeGuestDialogueConn,
	validate,
	getAppRoleConfByRoleId,
	updateAppRoleConfByRoleId
} from '/@/api/chat';
import { updateDialogueTaskInfos, pageDialogueTaskInfos,downloadFile,downloadGuestFile,
	updateCollectStatusByTask } from '/@common/api/index';

import { knowledgeAt, listKnowledgeBasePrompt, listChatBasePrompt } from '/@/api/knowledge';
import { setScrollPosition } from '/@common/utils/other';
import {useEventSource,RetriableError,RetriableJsonError,FatalError} from '/@common/hooks/useEventSource';
import { useRobotStore } from '/@/stores/robot';
import { useRoleConfig } from '/@/stores/role';
import { Message } from 'winbox-ui-next';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import { Local } from '/@common/utils/storage';
import removeMd from 'remove-markdown';
import { saveAs } from 'file-saver'
import {getTicketId} from "/@common/utils/utils.ts"

const robotStore = useRobotStore();
const roleConfig = useRoleConfig();
const { isMobile } = useBasicLayout();
const id = 1002;
const collapsedMeun=localStorage.getItem('collapsedMeun')? JSON.parse(localStorage.getItem('collapsedMeun')):true
const isOpen=localStorage.getItem('isOpen')? JSON.parse(localStorage.getItem('isOpen')):false
const setLocalState = (state: Chat.ChatState) => {
	Session.set('chatStorage', state);
};
const showTaskInfo=localStorage.getItem('showTaskInfo')?localStorage.getItem('showTaskInfo'):'0'
export const useChatStore = defineStore('chat-store', {
	state: (): Chat.ChatState => ({
		type:'chat',
		errorText: '网络开小差去了，请稍后再戳戳我',
		active: id,
		isLightTheme: true,
		conversationsId: 'new',
		conversationsIdforUploadFlag: 'new',
		usingContext: true,
		dialogueParams: {},
		dialogueLoading: false,
		history: [],
		chat: [{ id, data: [] }],
		chatList: [],
		debugChatList: [],
		fileList: [],
		appTreeList: [],
		paramsDrawerVisible: false,
		uploadDrawerVisible: false,
		chatLoading: false,
		paramsNum: 3,
		dialogueParamsList: [],
		dialogueParamsListOld: [],
		pluginListAll: [],
		abortController: null,
		clientId: '',
		answerStr: '',
		isOpen: isOpen,
		rightFlag: 1,
		scrollbarBottom: true,
		isShowRoleCard: false,
		timer: null,
		chatInputText: '', //指令传过来的文字
		chatInputTextValue: '', //input输入框中的文字
		webSourceList: [],
		isShowNoice: false,
		noticeData: {},
		currentBalance: 4,
		categoryId: '',
		isSensitive: false,
		isFirstConsume: false,
		collapsedMeun:collapsedMeun,
		uploadImgStatus: false,
		bgRoleId: '21', //角色id 默认21
		bgRoleName: i18n.global.t('chat.store.bgRoleName'),
		modelVersion: 'YAYI-V1-30B-8K',
		fileUpdateCV: {
			accept: '.png,.jpg,.jpeg,.PNG,.JPG,.JPEG',
			acceptFile: '.pdf, .txt',
			acceptFiles: '.pdf, .txt,.doc,.docx',
			suffixArrImg: ['png', 'jpg', 'jpeg'],
			suffixArrFile: ['doc', 'docx', 'pdf', 'txt'],
			uploadArrFile: ['doc', 'docx', 'pdf', 'txt', 'md'],
			acceptNew: '.png,.jpg,.jpeg,.pdf,.txt,.doc,.docx,.ppt,.pptx,.xls,.xlsx',
			list: [],
			status: false,
			url: '',
			data: {},
			files: [],
			imgUrl: [], //上传图片url结果
			uploadLists: [], //文档上传结果
		},
		caiForm: {
			popTitle: i18n.global.t('chat.store.caiFormTitle'),
			placeholder: i18n.global.t('chat.store.zanFormPlaceholder'),
			options: [],
		},
		zanForm: {
			popTitle: i18n.global.t('chat.store.caiFormTitle'),
			placeholder: i18n.global.t('chat.store.zanFormPlaceholder'),
			options: [],
		},
		datapanelParas: {
			show: 0,
			list: [],
			value: null,
			chat: [listChatBasePrompt],
			document: [listKnowledgeBasePrompt, knowledgeAt],
			config: {
				chat: [
					{
						icon: false,
						name: 'name',
						desc: 'prompt',
						category: 'categories',
						multiple: true,
					},
				],
				document: [
					{
						icon: false,
						name: 'name',
						desc: 'promptShow',
						multiple: false,
					},
					{
						icon: true,
						name: 'name',
						desc: '',
						multiple: true,
					},
				],
			},
		},
		pluginInfoMap: {},
		uploadNum: 0,
		inputUrlNum: 0,
		centerMaxWidth: 1000,
		showUpload: true,
		showCheck: false,
		changePluginList: false, //插件和创造力是否加载完成,
		isHavePlgin: false, //是否有插件开关
		pluginValue: true, //开关的值
		previewFlag: false, //预览开关
		previdewData: {},
		pluginFlag: false, //外层总禁止开关
		regenRawItem: {},
		stopChat:false,//停生成标志
		debugConversationId:'',//调试的会话ID
		debugeModelVersion:'',
		debugpluginSwitch:true,//调试插件开关
		showhistoryChat:false,//历史记录开关
		isShowLogInfo:false,//记录提示
		currentName:'',
		chatlistsLoading:false,
		conversationDetail:{},//对话记录详情
		productionLists:[],//作品列表
		isShowLongText:false,//是否显示长文内容窗口
		longTextContent:{},//长文内容窗口内容
		showDeepThinkPop:false,//显示深度思考引导
		deepThinkFlag: false,//是否深度思考模式
		showDeepThinkLine:false,//是否深度思考推流结束
		isHaveHistory:false,
		showTaskInfo:showTaskInfo,
		isLog:false,//来源历史会话
		appRolePubTips:true,//发布轮播图是否显示
		isPubLoadInfo:false,//发布开始加载详情等信息
		isReloadHistory:false,//历史对话是否重新加载
		getListHistory:false,//是否历史查询标志
		isShowFileParse:false,//是否显示政企报告
		fileParseContent:[],//政企报告内容

	}),
	getters: {
		// 取最后一个
		lastItem(state: Chat.ChatState) {
			const len = this.debugConversationId?state.debugChatList.length-1:state.chatList.length - 1;
			return (this.debugConversationId?state.debugChatList[len]:state.chatList[len]) || [];
		},
		getChatHistoryByCurrentActive(state: Chat.ChatState) {
			const index = state.history.findIndex((item) => item.id === state.active);
			if (index !== -1) return state.history[index];
			return null;
		},
		getChatByid(state: Chat.ChatState) {
			return (id?: number) => {
				if (id) return state.chat.find((item) => item.id === id)?.data ?? [];
				return state.chat.find((item) => item.id === state.active)?.data ?? [];
			};
		},
		getErrorText() {
			return i18n.global.t('chat.store.errorText');
		},
		getErrorText1() {
			return i18n.global.t('chat.store.errorText1');
		},
		getErrorText2() {
			return i18n.global.t('chat.store.errorText2');
		},
	},
	actions: {
		async setChatList(data: never, isRetry = false) {
			const delay = (n) => new Promise((r) => setTimeout(r, n * 1000));
			this.stopChat=false
			this.paramsDrawerVisible = false;
			this.uploadDrawerVisible = false;
			this.dialogueLoading = true;
			this.showUpload = true;
			this.fileUpdateCV.imgUrl = [];
			this.fileUpdateCV.uploadLists = [];
			this.fileUpdateCV.files = [];
			data.modelVersion = this.modelVersion || 'YAYI-V1-30B-8K';
			if(this.debugConversationId){
				data.modelVersion=this.debugeModelVersion
			}
			if (data.modelVersion == 'YAYI-V1-13B-8K') {
				data.modelVersion = 'YAYI-V1-30B-8K';
			}
			data.clientId = this.clientId = Math.round(Math.random() * 1000000000000000000).toString(36);
			const route = router.currentRoute.value;
			const { content, param, dialogueFileIds, dialogueFolderIds, paragraph, skillId } = JSON.parse(JSON.stringify(data));
			const tempData = JSON.parse(
				JSON.stringify({
					// answer: "关于巴黎奥运会的各方观点，可以从以下几个方面进行详细列举：[1][2]\n1. **开放办赛与参与性**：[1]\n- 巴黎奥运会强调“开放办赛”，突破界限，让更多人参与赛会、感受奥林匹克荣光。这种做法旨在增加奥运会的包容性和参与度，让更多的观众和参与者感受到奥运精神。[1][2][3][4][5]\n2. **可持续发展与环保**：[1]\n- 巴黎奥组委承诺将本届奥运会的碳足迹减少至以往水平，体现了对环境可持续性的重视。开幕式在塞纳河上举行，以及使用多个城市地标作为比赛场地，都是为了减少对环境的影响。[1][2][3][4][5]\n3. **时尚新兴项目**：[1]\n- 霹雳舞成为奥运“新兵”，展示了巴黎奥运会对时尚和新兴项目的接纳，这有助于吸引年轻观众，并使奥运会更加多元化。[1][2][3]\n4. **经济影响与遗产**：[1]\n- 有观点认为巴黎奥运会不仅是一场体育盛会，其品牌方与地方政府、体育俱乐部等合作，共同开展项目合作，宣传奥运会，并让更多法国民众参与体育运动，这将惠及百万法国人。[1][2][3][4][5]\n5. **文化融合与创新**：[1]\n   - 巴黎奥运会将开幕式移出传统体育馆，在塞纳河畔举行，这是历史上第一次。这种创新的做法得到了一些人的赞赏，",
					citations: [],
					// answer:'此前中国的探空火箭已经成功将探测器送入国际空间站进行科学实验和研究工作，此次计划的实施将\n```js 123123 ```\n为未来开展深层次的科学研究提供更加广阔的空间和资源平台。\n\n    目前该项目正在积极筹备当中，预计将于2021年发射升空的载人飞船也将搭载着宇航员前往火星和其他星球上执行各种重要的科研考察活动。同时还将建立一系列的基础设施和服务体系来支持未来的发展需求。',
					createTime: '',
					// answer: "好的，我们可以通过以下步骤来绘制这个饼图：\n1. 导入必要的库，例如 `matplotlib` 和 `seaborn`。\n2. 定义交通方式及其对应的使用比例。\n3. 使用 `matplotlib` 创建饼图并设置中文标题和图例。\n4. 显示图形。\n\n让我们开始吧。\n<code>\n```python\n\nimport matplot</code><code>lib.pyplot as plt\r\n\r\n# 数据\r\nlabels = ['步行', '骑车', '公交', '地铁', '私家车']\r\nsizes = [15, 20, 25, 30, 10]\r\n\r\n# 创建饼图\r\nfig, ax = plt.subplots()\r\nax.pie(sizes, labels=labels, autopct='%1.1f%%', startangle=90)\r\n\r\n# 设置标题和图例\r\nplt.title('交通",
					answer: '',
					param: param,
					question: content,
					loading: true,
					dialogueFileIds: JSON.parse(JSON.stringify(data))?.dialogueFileIds,
					dialogueFolderIds: JSON.parse(JSON.stringify(data))?.dialogueFolderIds,
					fileId: JSON.parse(JSON.stringify(data))?.fileId,
					fileUrl: JSON.parse(JSON.stringify(data))?.fileUrl,
					fileName: JSON.parse(JSON.stringify(data))?.fileName,
					fileIds: JSON.parse(JSON.stringify(data))?.fileName,
					type: JSON.parse(JSON.stringify(data))?.type,
					paragraph: paragraph,
					skillId: skillId,
					files: JSON.parse(JSON.stringify(data))?.files,
					checked: false,
					pluginSwitch: JSON.parse(JSON.stringify(data))?.pluginSwitch,
					stages: [],
				})
			);
			if (route.path.indexOf('aiSearch') != -1) {
				tempData.stages = [
					{
						type:"stagesInit",
					}
				];
			}

			if (!data.groupId) {
				if(this.debugConversationId){
					this.debugChatList.push(tempData)
				}else{
					this.chatList.push(tempData);
				}
			} else {
				this.lastItem.loading = true;
				this.lastItem.question = content;
				this.lastItem.answer = '';
				this.lastItem.citations = [];
				this.lastItem.checked = false;
				this.lastItem.answerFinish = false;
				this.lastItem.stages = [];
				if (route.path.indexOf('aiSearch') != -1) {
					this.lastItem.stages = [
						{
							type:"stagesInit",
						}
					];
				}
				tempData.regens = this.lastItem.regens || [];
			}

			this.scrollbarBottom = true;
			this.debugConversationId?	setScrollPosition('.debug-right'):setScrollPosition('.center-side');
			// return
			this.answerStr = '';
			const regRule = /(https?:\/\/[^\s]+(\.[^\s]+){1,})/g;
			if (data.files) {
				delete data.files;
			}
			if (this.isHavePlgin) {
				data.pluginSwitch = this.pluginValue;
			}
			// if (data.content && regRule.test(data.content)) {//去掉解析url后自动关闭插件逻辑
			// 	if ('pluginSwitch' in data) {
			// 		data.pluginSwitch = false;
			// 		this.pluginValue = false;
			// 		this.pluginFlag = true;
			// 	}
			// }
			//去掉上传后自动关闭插件逻辑
			// if (data.fileIds && data.fileIds.length) {
			// 	if ('pluginSwitch' in data) {
			// 		data.pluginSwitch = false;
			// 		if(this.debugConversationId){
			// 			this.debugpluginSwitch=false
			// 		}else{
			// 			this.pluginValue = false;
			// 			this.pluginFlag = true;
			// 		}
			// 	}
			// }
			if(this.debugConversationId){
				data.pluginSwitch=this.debugpluginSwitch
				// delete data.debugpluginSwitch
			}
			//去掉上传后自动关闭插件逻辑
			// if(data.fileIds && data.fileIds.length){
			// 	data.pluginSwitch=false
			// }
			if((this.deepThinkFlag)&&roleConfig.currentRole=='1658297003183144963'){//小雅深度思考
				data.isDeepthink=true
				// data.pluginSwitch=false
			}
			if(!this.deepThinkFlag&&data?.isDeepthink){
				delete data.isDeepthink
			}
			let dialogueByStream: any = tempData;
			dialogueByStream.checked = false;
			if (route.path.indexOf('aiSearch') != -1) {
				delete data?.pluginSwitch;
				// 打字机效果
				this.startTyping()			
			}
			await delay(0.5);
			
			try {
				this.setAiRobotChat('break', false, 'break');
				this.abortController = new AbortController();
				let originalAnswer = '';
				let searchAnswer = '';
				let stagesTemp = [];
				let dataUrl=getTicketId()?`${import.meta.env.VITE_API_URL}/api/guest/dialogue/dialogueByStream`:`${import.meta.env.VITE_API_URL}/api/dialogue/v3/dialogueByStream`
				useEventSource(dataUrl,
					data,
					this.abortController,
					(list) => {
						dialogueByStream.chatQuestion=data
						this.isFirstConsume = true;
						dialogueByStream = JSON.parse(list);
						if(dialogueByStream.appRoleIsDelete){//智能体被删除了
            				roleConfig.isDelete=dialogueByStream.appRoleIsDelete
						}
						let regensRaw = [];
						if (data.groupId) {
							regensRaw = this.lastItem.regens || [];
							dialogueByStream.regens = regensRaw;
						}

						this.isSensitive = dialogueByStream.sensitive;
						let index = this.history.findIndex((item) => item.id == data.conversationId);
						if (index !== -1) {
							this.history[index].isSensitive = dialogueByStream.sensitive;
						}
						if (dialogueByStream.isOverdue) {
							this.noticeData = {
								msg: i18n.global.t('chat.recharge.insufficientBalance'),
								id: -1,
							};
							this.isShowNoice = true;
						}
						if (Session.get('yayiFlag') === 'true') {
							const { answer = '' } = dialogueByStream;
							if (answer) {
								this.setAiRobotChat(answer.slice(originalAnswer.length, answer.length));
								originalAnswer = answer;
							}
						}

						// stages增量处理
						if (dialogueByStream.stages) {
							const { stages = [] } = dialogueByStream;
							if (stages.length) {
								stagesTemp.push(stages[0])
							}
							dialogueByStream.stages = stagesTemp
						}
						
						// ai搜索段落效果
						// if (this.type === 'search') {
						// 	const { answer = '' } = dialogueByStream;
						// 	if (answer) {
						// 		const addedContent = answer.replace(originalAnswer, ""); // 获取新增内容
						// 		console.log(addedContent);
						// 		if (addedContent) {
						// 			// 将新增内容包装在 <span> 标签中
						// 			const currentText = `<span class="fade-in">${addedContent}</span>`;
						// 			searchAnswer+=currentText
						// 			dialogueByStream.answer = searchAnswer;
						// 		}
						// 		console.log(dialogueByStream.answer);
						// 		originalAnswer = answer;
						// 	}
						// }				
						this.setAnswerStart(dialogueByStream)
						this.debugConversationId?	setScrollPosition('.debug-right','auto'):setScrollPosition('.center-side', 'auto');	
					},
					() => {
						dialogueByStream.chatQuestion=data
						// onclose
						// this.updateNameConversation();
						// this.firstConsumeTip();
						this.setAiRobotChat('。');
						// try {
						// 	const jsonObj = JSON.parse(text); // 将字符串解析为一个对象
						// 	const jsonFormatted = JSON.stringify(jsonObj, null, 2);
						// 	dialogueByStream.answer = '```json\n' + jsonFormatted + '\n```';
						// } catch (error) {
						// 	console.log('解析失败json',error);

						// }
								this.setLastItem(dialogueByStream)

							if (this.lastItem.answer === '') {
								this.handelError()
							} else {
								this.doFinally()
								this.stopPrint();
							}
							// clearInterval(this.timer);
							this.debugConversationId?	setScrollPosition('.debug-right','auto'):setScrollPosition('.center-side', 'auto');
					},
					(error) => {
						// onerror
						// 已知错误
						console.log('$$$$$$$ onerror',error, this.lastItem);

						// 已知错误: 如果错误是 RetriableError 类型，抛出错误
						if (error instanceof RetriableError) {
							console.log('RetriableError', error.content);
							this.handleStreamerror(error);
							throw error;
						}

						// 已知错误: 如果错误是 RetriableJsonError 类型，抛出错误
						if (error instanceof RetriableJsonError) {
							console.log('RetriableJsonError', error.content);
							this.handleStreamJsonerror(error);
							throw error;
						}

						let res = error;
						if (typeof error === 'object') {
							res = error.toString();
						}
						// 特殊处理: 如果是网络错误，抛出 RetriableError
						if (res === 'TypeError: network error') {
							console.log('网络错误: network error');
							this.handelNetworkError()
							throw new RetriableError('network');
						} else if (res === 'TypeError: Failed to fetch') {
							console.log('网络错误: network error');
							this.handelNetworkError()
							throw new RetriableError('network');
						}
						else {
							// 未知错误: 抛出一般错误
							console.log('抛出未知错误:', error);
							this.handelError()
							throw new Error(error);
						}
						// if (error instanceof TypeError) {
						// 	console.error('网络错误或CORS问题');
						// } else {
						// 	console.error('其他错误', error);
						// }
						// if (this.abortController) {
						// 	this.abortController?.abort();
						// }
						// // closeDialogueConn(this.clientId);
						// this.chatList[this.chatList.length - 1].answer = this.getErrorText1;
						// this.chatList[this.chatList.length - 1].loading = false;
						// this.dialogueLoading = false;
						// clearInterval(this.timer);
						// this.stopPrint()
					}
				);
			} catch (error) {
				console.log(error);
				this.handelError()
				this.stopPrint();
			} finally {
				dialogueByStream.chatQuestion=data
				// this.chatList[this.chatList.length - 1].loading = false;
			}
		},
		setAnswerStart(dialogueByStream) {
			try {
				// 问题打字机效果
				if (this.lastItem.questionLoading) {
					dialogueByStream.question = this.lastItem.question
					dialogueByStream.questionLoading = true
				}
				// citations 增量更新
				if (dialogueByStream.citations) {
					const { citations = [] } = dialogueByStream;
					if (!citations.length) {
						dialogueByStream.citations = this.lastItem.citations
					}
				} else {
					dialogueByStream.citations = this.lastItem.citations
				}
				
				dialogueByStream.checked = false;
				this.answerStr = dialogueByStream.answer;
				this.setLastItem(JSON.parse(JSON.stringify(dialogueByStream)))
				this.lastItem.loading = true;
				this.lastItem.question = dialogueByStream.question;
			} catch (error) {
				this.handleStreamJsonerror()
			}
		},
		closeEvent() {
			this.abortController?.abort()
		},
		handleStreamJsonerror() {
			this.lastItem.loading = false;
			this.lastItem.answer = '答案加载中，请稍候片刻...';
			this.lastItem.checked = false;
			this.stopPrint();
			this.doFinally();
		},
		handelNetworkError() {
			this.lastItem.answer = this.getErrorText1;
			this.lastItem.stages = [];
			this.stopChat = true
			Message.error({
				id: 'ERR_NETWORK',
				content: `${this.getErrorText1}`,
			});
			this.stopPrint('error');
			this.doFinally();
			this.closeEvent();
		},
		handelError() {	
			this.lastItem.answer = this.getErrorText;
			Message.error({
				id: 'ERR_NETWORK',
				content: `${this.getErrorText}`,
			});
			this.stopPrint('error');
			this.doFinally();
			this.closeEvent();
		},
		manualStopStream() {
			this.lastItem.loading = false;
			this.lastItem.answer = this.answerStr || i18n.global.t('chat.store.stopGenerate');
			this.lastItem.stages=[]//停止生成 stages为空
			this.lastItem.checked = false;
			this.stopPrint();
			this.doFinally();
			this.closeEvent();
		},
		// 最终
		doFinally() {
			if (!this.debugConversationId) {
				this.initChatDetail()
			}
			try {
				const route = router.currentRoute.value;
				DSBridge.callNative('endAnswer',{conversationId:route.params.conversationId || ''})
			}catch (error) {}
			this.lastItem.loading = false;
			this.dialogueLoading = false;
			roleConfig.initRoleConfig()
		},
		async handleStreamerror(err) {
			Message.error({
				id: 'ERR_NETWORK',
				content: `ERROR: ${err.content}`,
			});
			this.doFinally();
		},
		startTyping() {
			let typingInterval:any = null;
			let index = 0;
			const fullText = this.lastItem.question;
			this.lastItem.question = ''
			this.lastItem.questionLoading = true
			if (typingInterval) {
				clearInterval(typingInterval); // 如果已有定时器，先清除
			}
			typingInterval = setInterval(() => {
				if (index < fullText.length) {
					this.lastItem.question += fullText[index];
				index++;
				} else {
					clearInterval(typingInterval); // 显示完成后清除定时器
					this.lastItem.questionLoading = false
				}
			}, 50);
		},
		setLastItem(item:any) {
			if(this.debugConversationId){
				this.debugChatList[this.debugChatList.length - 1] = item
			}else{
				this.chatList[this.chatList.length - 1] = item;
			}		
		},
		async updateNameConversation() {
			if(this.debugConversationId){
				return
			}
			const route = router.currentRoute.value;
			const id = route.params.conversationId;
			if(!id){
				return
			}
			let api=getTicketId()?updateGuestDialogueName:updateNameConversation
			const list = await api(id);
			let index = this.history.findIndex((item) => item.id == id);
			if(index>=0){
				this.history[index].name = list.data;
			}
			
		},
		async initChatDetail(conversationId:string) {
			const route = router.currentRoute.value;
			const id = route.params.conversationId||conversationId;
			if(!id){
				return
			}
			let api=getTicketId()?updateGuestDialogueName:updateNameConversation
			await api(id)
			let detailApi=getTicketId()?conversationGuestDetail:detail
			let res=await detailApi(id)
			if(res?.code==200){
				this.conversationDetail=res?.data
			}else{
				Message.info(res?.msg)
				this.conversationDetail={}
			}
		},
		async initNewChatDetail(conversationId:string) {
			const route = router.currentRoute.value;
			const id = route.params.conversationId||conversationId;
			if(!id){
				return
			}
			let api=getTicketId()?updateGuestDialogueName:updateNameWithConversation
			await api(id)
			let detailApi=getTicketId()?conversationGuestDetail:detail
			let res=await detailApi(id)
			if(res?.code==200){
				this.conversationDetail=res?.data
			}else{
				Message.info(res?.msg)
				this.conversationDetail={}
			}
		},
		async initChatList(conversationId: number | string) {
			this.getListHistory=false
			await this.clearChat();
			this.chatLoading = true;
			let api=getTicketId()?listGuestDialogues:listDialogues
			const list = await api(conversationId);
			// this.modelVersion = list.data[0]?.modelVersion;
			this.chatLoading = false;
			if(this.debugConversationId){
				this.debugChatList=[]
			}else{
				this.chatList = [];
				this.initNewChatDetail(conversationId)
			}
			if (!list.data || !list.data?.dialogues || list.code === 500 || list.code === 403) {
				const route = router.currentRoute.value;
				router.push({ name: route.name, params: { appId: route.params.appId, conversationId: '' } });
				return true;
			}
			if(list?.data?.dialogues?.length){
				this.getListHistory=true
			}
			const mergedList = await this.mergeConversations(list.data.dialogues);
			if(this.debugConversationId){
				this.debugChatList=mergedList
			}else{
				this.chatList = mergedList;
				// this.chatList[0].answer = "要找到表达式 \\((a + \\frac{1}{b})(b + \\frac{1}{a})\\) 的最小值，我们可以使用基本不等式（AM-GM不等式）来解决这个问题。◹[4]◸\n\n首先，展开表达式：◹[4]◸\n\\[\n(a + \\frac{1}{b})(b + \\frac{1}{a}) = ab + a \\cdot \\frac{1}{a} + b \\cdot \\frac{1}{b} + \\frac{1}{ab}◹[4]◸\n\\]\n简化后得到：◹[4]◸\n\\[\nab + 1 + 1 + \\frac{1}{ab} = ab + 2 + \\frac{1}{ab}◹[10]◸\n\\]\n\n我们需要最小化 \\(ab + 2 + \\frac{1}{ab}\\)。为了应用AM-GM不等式，我们注意到 \\(ab\\) 和 \\(\\frac{1}{ab}\\) 是正数，因此可以应用AM-GM不等式：◹[4]◸\n\\[\nab + \\frac{1}{ab} \\geq 2\\sqrt{ab \\cdot \\frac{1}{ab}} = 2◹[10]◸\n\\]\n\n因此，\n\\[\nab + 2 + \\frac{1}{ab} \\geq 2 + 2 = 4◹[10]◸\n\\]\n\n所以，表达式 \\( (a + \\frac{1}{b})(b + \\frac{1}{a})\\) 的最小值为4。这个最小值在 \\(ab = 1\\) 时取得，即当 \\(a = b = 1\\) 时。◹[6]◸"
			}	
			// const reg = /(https?:\/\/[^\s]+(\.[^\s]+){1,})/g;//去掉url插件自动关闭
			// let flag = false;
			// let forData=this.debugConversationId?this.debugChatList:this.chatList
			// forData.forEach((item: object) => {
			// 	// if ((item.question && reg.test(item.question)) || (item.files && item.files.length)) {//去掉上传自动关闭插件
			// 		if ((item.question && reg.test(item.question))) {
			// 		flag = true;
			// 		this.pluginValue = false;
			// 		this.pluginFlag = true;
			// 		return;
			// 	}
			// });
			// if (!flag) {
			// 	this.pluginFlag = false;
			// }
			let arr = this.history.filter((m) => m.id == conversationId);
			this.isSensitive = arr[0]?.isSensitive;

			


			if (this.chatList.length) {
				this.chatList.forEach((item: object) => {
					item.checked = false;
					if(!item.answer){
						item.answer=this.getErrorText
					}
				});
				this.scrollbarBottom = true;
				this.debugConversationId ? setScrollPosition('.debug-right') : setScrollPosition('.center-side');
				
				await nextTick();
				setTimeout(() => {
					const targetElement = document.getElementById(`message-item-active`);
					if (targetElement) {
						// 滚动到目标元素
						targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
					}else{
						if(router.currentRoute.value.params?.dialogueId&&!getTicketId()){
							Message.info('作品对应的对话已被删除或替换，暂时无法查看')
						}
						
					}
				}, 300);
			}
		},
		async mergeConversations(data: any) {
			const mergedData: any = {};
			data.forEach((item) => {
				const { id, groupId } = item;
				const key = groupId || id;
				if (!mergedData[key]) {
					mergedData[key] = { curIndex: 0, ...item, regens: [] };
				}
				mergedData[key].regens.push(item);
			});


			Object.values(mergedData).forEach((item) => {
				const { id, groupId } = item;
				const key = groupId || id;
				const regens = item.regens;
				const selectedIndex = item.regens.findIndex((regen) => regen.isSelect === true);
				if (selectedIndex !== -1) {
					const switchItem = regens[selectedIndex];
					mergedData[key] = { ...switchItem, curIndex:selectedIndex, regens}
				}
			});
			return Object.values(mergedData);
		},
		stopPrint(type = '') {
			this.disposeRegenerateAnwser(type);
		},
		clearRightCard(){
			this.isShowLongText=false
			this.isShowFileParse=false
		},
		disposeRegenerateAnwser(type: string) {
			if (!this.lastItem.regens) {
				return;
			}

			//  调用该方法需要确保  printComleted or  manualStopStream  已经被设置为 true
			if (Object.keys(this.regenRawItem).length > 0) {
				
				// 设置状态
				let _regens = [this.regenRawItem];

				if (this.lastItem?.regens?.length) _regens = [...this.lastItem.regens];

				const _lastItem = { ...this.lastItem, regens: [..._regens] };
				if (type === 'error') {
					if(this.debugConversationId){
            this.debugChatList[this.debugChatList.length - 1] = this.regenRawItem
					}else{
						this.chatList[this.chatList.length - 1] = this.regenRawItem
					}
				} else {
					_regens.push(_lastItem);
				}

				this.lastItem.regens = _regens;
				this.lastItem.curIndex = _regens.length - 1;
				this.regenRawItem = {};
				return;
			}
		},
		getConversationName() {
			const route = router.currentRoute.value;
			const id = route.params.conversationId;
			let index = this.history.findIndex((item) => item.id == id);
			return this.history[index].name;
		},
		async clearChat() {
			if (this.abortController) {
				this.abortController?.abort();
			}
			if (this.clientId && (this.chatList.length||this.debugChatList.length)) {
				clearInterval(this.timer);
				let api=getTicketId()?closeGuestDialogueConn:closeDialogueConn
				await api(this.clientId);
				// this.updateNameConversation();
				this.manualStopStream();
				let setData=this.debugConversationId?this.debugChatList:this.chatList

				if (setData[setData.length - 1]?.resInfoState == 'ready') {
					setData[setData.length - 1].resInfoState = null;
				}

				this.setAiRobotChat('break', false, 'break');
				// this.firstConsumeTip();
			}
		},
		setFileList(data: never) {
			this.fileList.push(data);
		},
		setFileUpdate(params: any) {
			for (let i in params) {
				this.fileUpdateCV[i] = params[i];
			}
		},
		//新建对话
		async newBuilt(type?: string) {
			robotStore.breakChat();
			this.setParamsDrawerVisible(false);
			this.setUploadDrawerVisible(false);
			this.resetNewBuild()
			this.isSensitive = false;
			this.fileUpdateCV.url = '';
			this.fileUpdateCV.data = {};
			// this.modelVersion = roleConfig.currentRoleInformation.defaultModel || 'YAYI-V1-30B-8K'
			if (this.modelVersion == 'YAYI-V1-13B-8K') {
				this.modelVersion = 'YAYI-V1-30B-8K';
			}
			this.dialogueLoading = false;
			this.conversationDetail={}
			const route = router.currentRoute.value;
			let name =type?type:'chat';
			if(getTicketId()){
				let modelVersion=roleConfig?.currentRoleInformation?.defaultModel||null
		        let roleId=route.params?.appId||roleConfig.currentRole
				let resData = await validate()
				if(resData?.code == 200 && resData?.data){
					this.addHistory({ appId: this.bgRoleId,from:'',modelVersion:modelVersion,appRoleId: roleId })
				}else{
					Message.info(i18n.global.t('chat.center.infoSend'))
				}
				return
			}
			if ((name == 'chat' || name == 'chath5') && !getTicketId()) {
				router.push({ name: name, params: { appId: route.params.appId||21, conversationId: '' } });
			}else{
				if(getTicketId()){
					await router.push({ name: 'agentpub', params: { appId: route.params.appId||21,ticket:getTicketId(), conversationId: '' } });
					this.chatList=[]
				}else{
					router.push({ name: name, params: { conversationId: '' } });
				}
				
			}
		},
		async initFileList(data: never) {
			const list = await listFile(data);
			this.fileList = list.data;
		},
		setAiRobotChat(str: string, mark: boolean = false, type: boolean = false) {
			if (str === this.errorText) {
				return;
			}
			str = str.replace(/\n/g, '。');
			str = removeMd(str);
			str = str.replace(/:::r|:::|\n/g, '');

			str = str.replace(/\[\d+\]/g, '');
			if (mark || (this.isOpen && this.rightFlag == 2)) {
				robotStore.muted = false;
				robotStore.sendMsg(str, type);
			}
		},
		delFileList(id: number | string) {
			this.fileList.filter((m: any) => m.id == id);
			let id1 = this.fileList.findIndex((item: any) => item.id == id);
			this.fileList.splice(id1, 1);
		},
		setUsingContext(context: boolean) {
			this.usingContext = context;
			this.recordState();
		},
		//获取用户历史对话状态
		
		async getUserLogStatus() {
			let res=await getUserPreference()
			if(res?.code==200){
				if(res?.data&&res.data?.conversationIKnow==1){
					this.isShowLogInfo=true
				}
				if(res?.data&&res.data?.thinkIKnow==1){
					this.showDeepThinkPop=true
				}
				if(res?.data&&res.data?.appRolePubTips==0){
					this.appRolePubTips=false
				}
				if(res?.data&&res.data?.deepThinkSwitch !== undefined){
					this.deepThinkFlag=res.data.deepThinkSwitch == 0
				}
			}
		},
		async getRolePlufinStatus(id:string) {
			let appRoleId=id
			if(!appRoleId){
				return
			}
			let res=await getAppRoleConfByRoleId({appRoleId})
			if(res?.code==200){
				if(res?.data&&res.data?.pluginSwitch !== undefined){
					this.pluginValue=res.data.pluginSwitch
				}
			}
		},
		async setDeepThinkStatus() {
			//设置deepThink状态
			let data={
				deepThinkSwitch:this.deepThinkFlag?0:1
			}
			let res=await saveOrUpdateUserPreference(data)
			if(res?.code==200){
			}
		},
		async setPlugSwitchStatus() {
			//设置插件开关状态
			let data={
				pluginSwitch:this.pluginValue,
				appRoleId:router.currentRoute.value.params?.appId
			}
			// let res=await saveOrUpdateUserPreference(data)
			let res=await updateAppRoleConfByRoleId(data)
			if(res?.code==200){
			}
		},
		async setUserLogStatus() {
			//log已读状态
			let data={
				conversationIKnow:0
			}
			let res=await saveOrUpdateUserPreference(data)
			if(res?.code==200){
				localStorage.setItem('showInfoCard','false')
				this.isShowLogInfo=false
			}
		},
		async setAppRolePubTipsStatus() {
			let params={
				appRolePubTips:0
			}
			let res=await saveOrUpdateUserPreference(params)
				if(res?.code==200){
					this.appRolePubTips=false
				}
		},
		async setUserTaskStatus() {
			//Task已读状态
			let data={
				thinkIKnow:0
			}
			let res=await saveOrUpdateUserPreference(data)
			if(res?.code==200){
				this.showDeepThinkPop=false
			}
		},
		resetNewBuild(){
			this.getListHistory=false
		},
		// clearDeepThinkStatus(){
        //    //deepThink状态初始化
		//    const deepThinkFlag=localStorage.getItem('deepThinkFlag')?JSON.parse(localStorage.getItem('deepThinkFlag')):false
        //    this.deepThinkFlag=deepThinkFlag
        //    this.showDeepThinkPop=false
		// },
		clearDeepThink(){
			this.isHaveHistory=false
			// this.deepThinkFlag=false
			this.showDeepThinkPop=false

		},
		resetFields(){
			//重置上传相关的lists
			this.inputUrlNum=0
			this.fileUpdateCV.uploadLists=[]
			this.fileUpdateCV.imgUrl=[]
			this.fileUpdateCV.files=[]
		},
		async getConversationList(aid: number | string, cid: number | string) {
			this.clearChat();
			let data = {
				appId: aid,
			};
			const list = await listConversations(data);
			list.data = list.data || [];
			this.history = list.data;
			this.active = cid;
			this.reloadRoute(cid);
		},

		async getConversationListByPage(appId: string, c: number, cid: number | string, isCollect: any,keywords:string,appRoleId:string,time) {
			if(this.chatlistsLoading){
				return
			}
			let data = {
				current: c,
				size: 50,
				appId: '',
				isCollect: isCollect,
				keywords:keywords,
				appRoleId:appRoleId,
				updateTimeRange:time
			};
			this.chatlistsLoading=true
			const list = await listConversationsByPage(data);
			this.chatlistsLoading=false
			const isFirstPage = c === 1;
			const {
				data: { current, size, total, records = [] },
			} = list;

			if (isFirstPage) {
				this.history = records;
			} else {
				this.history.push(...records);
			}
			this.active = cid;

			// await this.reloadRoute(cid);

			this.getBgRoleName(this.active);

			return current * size >= total;
		},
		//获取作品列表
		async getproductionListsByPage(data:object){
			
			if(this.chatlistsLoading){
				return
			}
			const isFirstPage = data.current === 1;
			this.chatlistsLoading=true
			let res=await pageDialogueTaskInfos(data)
			const {
				data: { current, size, total, records = [] },
			} = res;
			if(res?.code==200){
				if (isFirstPage) {
					this.productionLists = records;
				} else {
					this.productionLists.push(...records);
				}
				this.chatlistsLoading=false
			}else{
                Message.info(res?.msg)
				this.chatlistsLoading=false
			}
			return current * size >= total;
			
		},

		async addHistory(data: object, history: Chat.History, chatData: Chat.Chat[] = []) {
			if (this.abortController) {
				this.abortController?.abort();
			}
			const route = router.currentRoute.value;
			!data.modelVersion && (data.modelVersion = this.modelVersion || 'YAYI-V1-30B-8K');
			let params={
				appId:data.appId,
				appRoleId:data.appRoleId,
				modelVersion:data.modelVersion,
				isDebug:data.from=='debug'?true:false
			}
			if(data?.type&&data?.type=='upload'){
				params.isUpload=true
			}
			let api=getTicketId()?guestConversationAdd:addConversation
			const list = await api(params);
			if(list.code!=200){
				Message.error({
					id: 'add_error',
					content: list.msg,
				});
				return
			}
			this.debugeModelVersion=list.data.modelVersion
			if(data?.from=='debug'){
				this.debugConversationId= list.data.id
			}else{
				this.conversationsId = list.data.id;
			}
			this.bgRoleName = list.data.roleName;
			this.conversationsIdforUploadFlag = list.data.id;
			// this.getConversationListByPage(route.params.appId as string, 1, route.params.conversationId as string, null);

			this.active = list.data.id;
			if(data.from!='debug'||!data.from){
				await this.reloadRoute(list.data.id);
			}
		},

		async updateHistory(id: number, name: string, edit: Partial<Chat.History>, isCancel: false) {
			if (!edit.isEdit && !isCancel) await updateConversation({ id, name });
			this.history = this.history.map((item) => {
				if (item.id === id) {
					return { ...item, ...edit, name };
				}else{
					item.isEdit=false
				}
				return item;
			});
			this.recordState();
		},
		async updateProductionName(data:any,name:string) {
			
			let dataParms={
				id:data.id,
				taskName:name
			}
			let res=await updateDialogueTaskInfos(dataParms)
			if(res?.code==200){
				data.taskName=name
			}else{
				Message.info(res?.msg)
			}
		},
		async downLoadProduction(data:object){
			const formData = new FormData()
			formData.append('html', data.html);
			formData.append('format', data.format);
			formData.append('name', data.name);
			Message.info({
				content: `${data.format}文件生成中...`,
				duration: 1000,
				id: 'myInfo',
			})
			let typeModel= data.format=='word'?'application/msword':'application/pdf'
			let api=getTicketId()?downloadGuestFile:downloadFile
			api(formData).then((res) => {
				const blob = new Blob([res],{type: `${typeModel};charset=utf-8`});
				// saveAs(blob,  data.name)
				if ('download' in document.createElement('a')) {
					//非IE下载
					const a = document.createElement('a'); //创建一个a标签
					a.download = data.name; //指定文件名称
					a.style.display = 'none'; //页面隐藏
					a.href = URL.createObjectURL(blob); // href用于下载地址
					document.body.appendChild(a); //插到页面上
					a.click(); //通过点击触发
					URL.revokeObjectURL(a.href); //释放URL 对象
					document.body.removeChild(a); //删掉a标签
				} else {
					navigator.msSaveBlob(blob, data.name);
				}
				// Message.clear()
			})
			.catch((err) => {
				console.log(err);
				// Message.clear()
			});
		},
		async collectHistory(item: any) {
			let data = {
				id: item.id,
				isCollect: !item.isCollect ? 1 : 0,
			};
			await updateCollectStatus(data);
			item.isCollect = data.isCollect;
		},
		async collectHistoryByproduction(item:any,index:number){
			//接口
			let isCollect=item.isCollect?0:1
			let res=await updateCollectStatusByTask(item.id,isCollect)
			if(res?.code==200){
				item.isCollect=!item.isCollect
			}else{
				Message.info(res?.msg)
			}
			

		},

		async deleteHistory(id: number, index: number) {
			await deleteConversation(id);
			this.history.splice(index, 1);
			this.chat.splice(index, 1);

			if (this.history.length === 0) {
				this.active = null;
				this.reloadRoute();
				return;
			}

			if (index > 0 && index <= this.history.length) {
				const id = this.history[index - 1].id;
				this.active = id;
				this.reloadRoute(id, {});
				return;
			}

			if (index === 0) {
				if (this.history.length > 0) {
					const id = this.history[0].id;
					this.active = id;
					this.reloadRoute(id, {});
				}
			}

			if (index > this.history.length) {
				const id = this.history[this.history.length - 1].id;
				this.active = id;
				this.reloadRoute(id, {});
			}
		},

		async setActive(id: number | string, isSensitive: boolean, modelVersion: string,appRoleId?:string) {	
			this.isSensitive = isSensitive;
			this.modelVersion = modelVersion;
			this.active = id;
			if(appRoleId=='1793970575391633410'){
			this.isLog=true
			await router.push({ name:'aiSearch', params: { conversationId: id || '' }});
			}else if(appRoleId=='1829676855482630146'){
			this.isLog=true
			await router.push({ name:'assistant', params: { conversationId: id || '' }});
			}else{
				await router.push({ name: 'chat', params: { appId: appRoleId || 21, conversationId: id || '' } });
			}
			// await this.reloadRoute(id, {});
		},
		getBgRoleName(roleId: number | string) {
			let index = this.history.findIndex((item) => item.id == roleId);
			if (index != -1) {
				this.bgRoleName = this.history[index].appRoleName;
			}
		},
		async getChatList(id: number | string) {
			this.active = id;
			if(this.debugConversationId){
        this.debugChatList=[]
			}else{
				this.chatList = [];
			}	
			if (id) {
				await this.initChatList(id);
			}
		},
		async getLastChatList(){
            this.chatList = [];
			await this.clearChat();
			this.chatLoading = true;
			const list = await getLatestConversation();
			this.chatLoading = false;
			if(list?.code==200&&list?.data){
				if(list.data?.id){
				const route = router.currentRoute.value;
				await router.push({ name: 'agentpub', params: { appId: route.params.appId,ticket:getTicketId(), conversationId:list.data?.id || '' }});
	            await this.initChatList(list.data?.id);
				}
			}
		},
		setParamsDrawerVisible(flag: boolean) {
			this.paramsDrawerVisible = flag;
		},
		setUploadDrawerVisible(flag: boolean) {
			this.uploadDrawerVisible = flag;
		},
		async getFeedbackZanList() {
			const route = router.currentRoute.value;

			let roleId=route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId
			const res = await feedbackListLabel(roleId,1);
			if (res.code == 200) {
				this.zanForm.options = res.data;
			}
				
		},
		async getFeedbackCaiList(){
			const route = router.currentRoute.value;
			let roleId=route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId
			const list = await feedbackListLabel(roleId,0);
			if (list?.code == 200) {
				this.caiForm.options = list.data;
			}
		},	
		async getFeedbackList() {
			if(!getTicketId()){
				const route = router.currentRoute.value;
				let roleId=route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId
				const res = await feedbackListLabel(roleId,1);
				if (res.code == 200) {
					this.zanForm.options = res.data;
				}
				const list = await feedbackListLabel(roleId,0);
				if (list?.code == 200) {
					this.caiForm.options = list.data;
				}
			}
		},
		async getPersonagePriceFun() {
			const delay = (n) => new Promise((r) => setTimeout(r, n * 1000));
			const res = await getPersonagePrice(true);
			const count = this.currentBalance - res?.data.currentBalance;
			if (this.currentBalance == res?.data.currentBalance) {
				await delay(0.5);
				this.getPersonagePriceFun();
			} else {
				if (!isMobile.value) {
					Message.warning({
						id: 'firstConsumeTip',
						content: () => {
							return h('div', [
								`${i18n.global.t('chat.recharge.message1')} ${count} tokens，${i18n.global.t('chat.recharge.message2')} ${
									res?.data.currentBalance
								} tokens`,
								h(
									'span',
									{
										id: 'detail-text',
										onClick: () => {
											this.handleClickDetail();
										},
									},
									`${i18n.global.t('chat.recharge.goRecharge')}>`
								),
								'',
							]);
						},
						duration: 5000,
					});
				}
				Session.set('firstPay', false);
			}
		},
		async firstConsumeTip() {
			if (Session.get('firstPay') == 'true' && this.isFirstConsume) {
				try {
					// this.getPersonagePriceFun();
				} catch (err) {
					throw new Error(err);
				}
			}
		},
		async handleClickDetail() {
			router.push({
				path: '/personal/voucherPage',
			});
		},
		async reloadRoute(id?: number | string, querys?: object) {
			const route = router.currentRoute.value;
			const query = querys ? querys : route.query;
			if(!getTicketId()){
				await router.push({ name: route.name, params: { appId: route.params.appId, conversationId: id || '' }, query });
			}else{
				await router.push({ name: route.name, params: { appId: route.params.appId,ticket:getTicketId(), conversationId: id || '' }, query });
			}
			
		},

		recordState() {
			setLocalState(this.$state);
		},
		async getPluginInfo(param: { code: string }) {
			const paramCode = param.code;
			if (this.pluginInfoMap[paramCode]) return;
			const { data, code } = await getPluginInfo(param);
			if (code !== 200) {
				// 暂不展示错误信息
				return;
			}
			this.pluginInfoMap[paramCode] = data;
		},
		setDialogueParamsList(list: []) {
			this.dialogueParamsList = list;
		},
		serDebugChatList(val: any) {
			if (Object.prototype.toString.call(val) === '[object Object]') {
				this.debugChatList.push(val);
			} else {
				this.debugChatList = val;
			}
		},
		changeDebugChatList(val) {
			this.debugChatList[this.debugChatList.length - 1].answer = val;
		},
	},
});
